// extracted by mini-css-extract-plugin
export default {"link":"ZAwAR","container":"JxXi1","icon":"_ZO5O"};